export default __webpack_public_path__ + "static/media/mobile_banner_contact.467f922a.jpg";